import type { ReactElement, ReactNode } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { Notice } from '../../components-ui/Notice';
import { useTrendSignalsFlag } from '../../hooks/useTrendSignalsEnabled';

import { carryGlobalParams } from '../carryGlobalParams';
import { PATHS } from '../paths';

// Renders nothing until the team's flags are known, so a cold-loaded deep link is not bounced.
export function RequireTrendSignals({ children }: { children: ReactNode }): ReactElement | null {
  const { enabled, resolved, failed } = useTrendSignalsFlag();
  const location = useLocation();
  if (failed) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center px-4">
        <Notice tone="error" role="alert" className="max-w-md">
          Trend Signals couldn't load. Refresh the page to try again.
        </Notice>
      </div>
    );
  }
  if (!resolved) return null;
  if (!enabled) return <Redirect to={{ pathname: PATHS.APP.PORTFOLIOS, search: carryGlobalParams(location.search) }} />;
  return <>{children}</>;
}
